import { createSlice } from "@reduxjs/toolkit";

export const globalSlice = createSlice({
  name: "global",
  initialState: {
    refreshFlags: {},
  },
  reducers: {
    triggerRefresh(state, action) {
      state.refreshFlags[action.payload] = true;
    },
    resetRefresh(state, action) {
      state.refreshFlags[action.payload] = false;
    },
    resetAllRefreshes(state) {
      state.refreshFlags = {};
    },
  },
});

export const { triggerRefresh, resetRefresh, resetAllRefreshes } =
  globalSlice.actions;
export default globalSlice.reducer;
